<div class="page-print">
	@if (isDemo) {
	<div class="watermark">
		<p>{{ labels().WATERMARK_DEMO }}</p>
	</div>
	}
	<div class="menu-print">
		<div class="voice-menu">
			<span><strong>{{ labels().NAVBAR_COMPONENT_PATIENT_ID }}</strong> {{plan?.patient?.number}}</span>
			<span><strong>{{ labels().NAVBAR_COMPONENT_PLAN_ID }}</strong> {{plan?.number}}</span>
			<span><strong>{{ labels().NAVBAR_COMPONENT_PLAN_SIDE }}</strong> {{plan?.side | anatomicalSideLabel}}</span>
			<span><strong>{{ labels().NAVBAR_COMPONENT_PLAN_BONE_TYPE }}</strong> {{plan?.boneType | boneTypeLabel}}</span>
			<span style="font-size: 13pt"><strong> {{ labels().PRINT_OR_PLAN_MAIN_TITLE }} </strong></span>
			<span class="d-inline-block position-relative">
				<strong>{{ today | convertDate:false:true }}</strong>
				<span class="date-format date-format-subscript text-dark">{{ dateFormat }}</span>
			</span>
		</div>
		<span class="logo-text">{{ labels().APP_LOGO_TEXT }}</span>
	</div>
	<div class="wrapper-content">

		<ng-content></ng-content>

		<div class="row justify-content-end">{{ labels().PRINT_BOTTOM_RIGHT_PAGE_TEXT }}</div>
	</div>
</div>